module.exports = __webpack_public_path__ + "static/media/27OCHA17.ae7da55c.jpg";